import {request} from '@/helpers/apiClient';
import {DROPDOWN_CONFIG} from '@/utils/constants/apiConfig/dropdownConfig';
import {POINT_MULTIPLIER_CONFIG} from '@/utils/constants/apiConfig/pointMutliplierConfig';
import {DROPDOWN_TYPES} from '@/utils/constants/dropdownConstants';
import {createRequestGate} from '@/helpers/requestGate';

const dropdownGate = createRequestGate();

export const handleGetDropdownList = async (dropdownType) => {
  const key = String(dropdownType || '');
  return dropdownGate({
    key,
    fetcher: async () => {
      switch (dropdownType) {
        case DROPDOWN_TYPES.SalesTargetType:
          return await request(DROPDOWN_CONFIG.SALES_TYPE_DROPDOWN_LIST);
        case DROPDOWN_TYPES.ActivitiesType:
          return await request(DROPDOWN_CONFIG.ACTYVITY_TYPE_DROPDOWN_LIST);
        case DROPDOWN_TYPES.OrderType:
          return await request(DROPDOWN_CONFIG.ACTYVITY_TYPE_ORDER_TYPE);
        case DROPDOWN_TYPES.CustomerType:
          return await request(DROPDOWN_CONFIG.CUSTOMER_TYPE_DROPDOWN_LIST);
        case DROPDOWN_TYPES.StoreSelector:
          return await request(DROPDOWN_CONFIG.STORE_SELECTOR_DROPDOWN_LIST);
        case DROPDOWN_TYPES.Actions:
          return await request(DROPDOWN_CONFIG.ACTIONS_DROPDOWN_LIST);
        case DROPDOWN_TYPES.Schedule:
          return await request(DROPDOWN_CONFIG.SCHEDULE_DROPDOWN_LIST);
        case DROPDOWN_TYPES.PointMultiplierRulesCriteria:
          return await request(
            POINT_MULTIPLIER_CONFIG.RULES_CRITERIA_DROPDOWN_LIST
          );
        case DROPDOWN_TYPES.PointMultiplierSegment:
          return await request(POINT_MULTIPLIER_CONFIG.SEGMENT_DROPDOWN_LIST);
        case DROPDOWN_TYPES.PointMultiplierCategory:
          return await request(POINT_MULTIPLIER_CONFIG.CATEGORY_DROPDOWN_LIST);
        case DROPDOWN_TYPES.PointMultiplierChannel:
          return await request(
            POINT_MULTIPLIER_CONFIG.ORDER_CHANNEL_DROPDOWN_LIST
          );
        case DROPDOWN_TYPES.RewardsCatalogAction:
          return await request(DROPDOWN_CONFIG.REWARDS_CATALOG_ACTION_LIST);
        case DROPDOWN_TYPES.RewardTypes:
          return await request(DROPDOWN_CONFIG.REWARD_TYPES_DROPDOWN_LIST);
        case DROPDOWN_TYPES.RewardSegments:
          return await request(DROPDOWN_CONFIG.REWARD_SEGMENTS_DROPDOWN_LIST);
        case DROPDOWN_TYPES.BonusProducts:
          return await request(DROPDOWN_CONFIG.BONUS_PRODUCTS_DROPDOWN_LIST);
        case DROPDOWN_TYPES.RewardCardTypes:
          return await request(DROPDOWN_CONFIG.VISA_CARD_DROPDOWN_LIST);
        default:
          throw new Error(`Unsupported dropdown type: ${dropdownType}`);
      }
    }
  });
};
